module.exports = __webpack_public_path__ + "static/media/11.97bcb4b8.jpg";